import { render, staticRenderFns } from "./addChat.vue?vue&type=template&id=1c596e06&"
import script from "./addChat.vue?vue&type=script&lang=js&"
export * from "./addChat.vue?vue&type=script&lang=js&"
import style0 from "./addChat.vue?vue&type=style&index=0&id=1c596e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports